import { render, staticRenderFns } from "./DadjokesSupport.vue?vue&type=template&id=6e5ba968&"
import script from "./DadjokesSupport.vue?vue&type=script&lang=js&"
export * from "./DadjokesSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports